import { createActionGroup, props } from '@ngrx/store';
import {CustomerUpdateRequest} from "@fitup-monorepo/core/lib/model/customer-request";

export const accountDetailsEditorActions = createActionGroup({
  source: 'Account Details Editor Page',
  events: {
    ['Update Customer']: props<{ request: CustomerUpdateRequest }>()
  }
});
